/**
 * Konkord: click helpers for floating menus, with no imports (see index.ts)
 */

/**
 * Konkord: mark a click inside a menu that stays open while picking (the
 * menu's own buttons still get it; stopping the click would also stop
 * Solid's onClick handlers, which listen on the document)
 */
export function keepFloatingOpen(event: Event) {
  (event as Event & { konkordKeepOpen?: boolean }).konkordKeepOpen = true;
}

/**
 * Konkord: the click that follows a press outside an open menu only closes
 * the menu, like Esc (it would otherwise also hit what's under the cursor:
 * shrinking the focused stream, muting...). Keyboard clicks pass.
 */
export function swallowNextClick() {
  const until = performance.now() + 1000;
  const swallow = (event: MouseEvent) => {
    window.removeEventListener("click", swallow, true);
    if (event.detail === 0 || performance.now() > until) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  window.addEventListener("click", swallow, true);
  // released somewhere else: no click comes, stop waiting for it
  setTimeout(() => window.removeEventListener("click", swallow, true), 1000);
}
